export const ViewMinimiseIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1734_50653)">
        <path
          d="M11.8828 5.51562V9.26562H15.6328"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.8828 4.26562L11.8828 9.26562"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.63281 11.7656H9.38281V15.5156"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.38281 16.7656L9.38281 11.7656"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1734_50653">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.632812 0.515625)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
